import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import CompanyDashboardInitiativeTable from "./company-dashboard-initiative-table/company-dashboard-initiative-table";
import CompanyDashboardInitiativeAddDrawer from "./company-dashboard-initiative-add-drawer/company-dashboard-initiative-add-drawer";
import { getAllInitiative } from "../../../api/initiative";
import AlertComponent from "../../../common/components/alert-component/alert-component";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import "./company-dashboard-initiative.scss";
import { useSelector } from "react-redux";

const CompanyDashboardInitiative: any = (props: any) => {
  const objective = useSelector((state: any) => state.dashboard.tab);

  useEffect(() => {}, [objective]);
  const {
    isShowAddInitiativeTableDrawer,
    setIsShowAddInitiativeTableDrawer,
    setLoading,
    status,
    year,
    employeesList,
    statusListKeyResults,
    statusListObjectives,
    statusListInitiatives,
    initiativeData,
    setInitiativeData,
    initiativeId,
    setInitiativeId,
    objectiveId,
    setObjectiveId,
    keyResultId,
    setKeyResultId,
    fetchUpcomingMilestones,
    isFromObjective,
    setObjective,
    setIsFromObjective,
    setIsShowAddAllObjectiveDrawer,
    departmentsList,
    isShowMessageLoading,
    fetchAllYearsForInitiatives,
    fetchAllYearsForObjectives,
    departments,
  } = props;

  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const fetchInitiatives = async () => {
    setLoading(true);
    try {
      const response = await getAllInitiative({ status, year, departments });
      setInitiativeData(response.data.data);
      setLoading(false);
    } catch (error: any) {
      setInitiativeData([]);
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch initiatives",
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (year && !isShowAddInitiativeTableDrawer) {
      fetchInitiatives();
    }
  }, [status, year, departments, isShowAddInitiativeTableDrawer]);

  useEffect(() => {
    if (!isShowAddInitiativeTableDrawer) {
      setInitiativeId(null);
      setObjectiveId(null);
      setKeyResultId(null);
      if (isFromObjective === "upcoming milestones") {
        setObjective("Objectives");
        setIsFromObjective("");
      }
    }
  }, [isShowAddInitiativeTableDrawer, isFromObjective]);

  return (
    <div className="company-dashboard-initiative">
      <AlertComponent
        message={alertMessage}
        type={alertType ?? "info"}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      <div className="company-dashboard-all-objective-add-drawer-main-content-section-label">
        <div>List Of Initiatives</div>
      </div>
      <OverlayScrollbarsComponent
        options={{
          overflow: { x: "scroll", y: "scroll" },
          scrollbars: {
            theme: "os-theme-dark",
            autoHide: "scroll",
            autoHideDelay: 400,
          },
        }}
      >
        {isShowMessageLoading ? (
          ""
        ) : (
          <CompanyDashboardInitiativeTable
            onRowClick={(row: any) => {
              setInitiativeId(row?.initiativeId);
              setObjectiveId(row?.objectiveId);
              setKeyResultId(row?.keyResultId);
              setIsShowAddInitiativeTableDrawer(true);
              setObjective("Initiatives");
            }}
            initiativeData={initiativeData}
            setIsShowAddInitiativeTableDrawer={
              setIsShowAddInitiativeTableDrawer
            }
            setInitiativeId={setInitiativeId}
            setObjectiveId={setObjectiveId}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            setLoading={setLoading}
            fetchInitiatives={fetchInitiatives}
          />
        )}
        <Drawer
          anchor={"bottom"}
          open={isShowAddInitiativeTableDrawer}
          onClose={(event, reason) => {
            if (reason === "backdropClick") {
              return;
            }
            setIsShowAddInitiativeTableDrawer(false);
            setInitiativeId(null);
            fetchUpcomingMilestones({});
          }}
        >
          <CompanyDashboardInitiativeAddDrawer
            setIsShowInitiativeDrawer={setIsShowAddInitiativeTableDrawer}
            employeesList={employeesList}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            setLoading={setLoading}
            initiativeId={initiativeId}
            setInitiativeId={setInitiativeId}
            objectiveId={objectiveId}
            setObjectiveId={setObjectiveId}
            keyResultId={keyResultId}
            setKeyResultId={setKeyResultId}
            fetchInitiatives={fetchInitiatives}
            statusListKeyResults={statusListKeyResults}
            statusListObjectives={statusListObjectives}
            statusListInitiatives={statusListInitiatives}
            fetchUpcomingMilestones={fetchUpcomingMilestones}
            setObjective={setObjective}
            setIsShowAddAllObjectiveDrawer={setIsShowAddAllObjectiveDrawer}
            departmentsList={departmentsList}
            fetchAllYearsForInitiatives={fetchAllYearsForInitiatives}
            fetchAllYearsForObjectives={fetchAllYearsForObjectives}
          />
        </Drawer>
      </OverlayScrollbarsComponent>
    </div>
  );
};

export default CompanyDashboardInitiative;
